module.exports = __webpack_public_path__ + "img/sign-in-bg.jpg";